import * as _ from "lodash";

import AdminSettings from "src/pages/Admin/Settings";
import { IRoute } from "src/pages/Router/routes";

import LeadTimesSettingsPage from "./LeadTimesSettingsPage";
import LeadTimeOverridesPage from "./LeadTimeOverridesPage";
import CreateEditLeadTimeOverridePage from "./CreateEditLeadTimeOverridePage";

const LeadTimeRoutes: IRoute[] = [
  {
    exact: true,
    path: "/platform/lead-times",
    title: "Lead Times",
    pageComponent: LeadTimesSettingsPage,
    parent: AdminSettings[ 0 ],
    menuType: "ADMIN_LEAD_TIME_SETTINGS",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: []
  },
  {
    exact: true,
    path: "/platform/lead-time-overrides",
    title: "Lead Time Overrides",
    parent: AdminSettings[ 0 ],
    pageComponent: LeadTimeOverridesPage,
    menuType: "ADMIN_LEAD_TIME_SETTINGS",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: [],
    modules: [ "lead-time-override" ]
  }
];

const LeadTimeEditRoutes: IRoute[] = [
  {
    exact: true,
    path: "/platform/lead-time-overrides/new",
    title: "Save Override",
    pageComponent: CreateEditLeadTimeOverridePage,
    menuType: "EMPTY",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: [ "create-global-settings" ],
    roles: [ "admin" ],
    modules: [ "lead-time-override" ],
    parent: _.find(LeadTimeRoutes, route => route.title === "Lead Time Overrides")
  },
  {
    exact: true,
    path: "/platform/lead-time-overrides/edit/:leadTimeOverrideId",
    title: "Save Override",
    pageComponent: CreateEditLeadTimeOverridePage,
    menuType: "EMPTY",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: [ "amend-global-settings" ],
    roles: [ "admin" ],
    modules: [ "lead-time-override" ],
    parent: _.find(LeadTimeRoutes, route => route.title === "Lead Time Overrides")
  }
];

export default [ ...LeadTimeRoutes, ...LeadTimeEditRoutes ];
